import { QueryClient } from '@tanstack/react-query';

export const pmaQueryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, refetchOnWindowFocus: false, retry: 1 },
  },
});
